// extracted by mini-css-extract-plugin
export default {"page":"DigitalMarketing_page__24u2j"};